export const jobStates = Object.freeze({
    "Waiting": 'queued', 
    "Executing": 'executing', 
    "Finished": 'finished',
    "Retrying": 'retrying',
    "Failed": 'failed',
});